const LinkedHashMap = require('../../util/vendors/LinkedHashMap');

/*@ngInject*/
const FormViewerModel = function ($rootScope, $q, $timeout, fieldType, formComponentUtil, formStructureUtil, formViewerConstant, rowRepeaterUtil, supplementalFormUtil, formViewerUtil, formatUtil, formConfigurationUtil) {

    let formViewerModel = {};

    function reset(rootFormId) {
        let formViewerInstance;

        formViewerModel[rootFormId] = {
            formStructure: {},
            rowRepeaterMap: {},
            formIdList: [],
            fieldMap: null
        };

        formViewerInstance = formViewerModel[rootFormId];

        if (!formViewerInstance.fieldMap) {
            formViewerInstance.fieldMap = new LinkedHashMap();
        }
        formViewerInstance.fieldMap.clear();
    }

    function deleteSupplementalForm(supplementalForm, rootFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            sectionList = formViewerInstance.formStructure.sectionList,
            fieldMap = formViewerInstance.fieldMap,
            supplementalFormIdIndex = formViewerInstance.formIdList.indexOf(parseInt(supplementalForm.id));

        formViewerInstance.formIdList.splice(supplementalFormIdIndex, 1);
        supplementalFormUtil.deleteSupplementalForm(supplementalForm, sectionList, fieldMap);
    }

    function insertSupplementalForm(supplementalForm, rootFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            sectionList = formViewerInstance.formStructure.sectionList;

        formViewerInstance.formIdList.push(parseInt(supplementalForm.formModel.id));

        supplementalFormUtil.insertSupplementalForm(supplementalForm, sectionList);
    }

    function buildFormStructure(rootFormId, sourceForm, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, sectionList, printPreview, currencyCode, isConfigurableForm) {
        let formViewerInstance = formViewerModel[rootFormId],
            rowRepeaterMap = formViewerInstance.rowRepeaterMap,
            fieldMap = formViewerInstance.fieldMap;

        return formStructureUtil.buildFormStructure(rootFormId, sourceForm, fieldInstanceList, formSummaryList, formRowInstanceList,
            hasWriteAccess, rowRepeaterMap, fieldMap, null, printPreview, currencyCode, isConfigurableForm);
    }

    this.buildForm = function (rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview, snippets, effectiveDate, currencyCode) {
        let promiseList = [],
            formRoot = uiFormTemplateList[0],
            formViewerInstance,
            sectionList,
            rowRepeaterMap,
            supplementalFormList = _.filter(uiFormTemplateList, function (uiFormTemplate) {
                return uiFormTemplate.precedingFieldFormTemplateUniqueName && uiFormTemplate.precedingFieldVariableName;
            }),
            isConfigurableForm = false;

        reset(rootFormId);
        formViewerInstance = formViewerModel[rootFormId];
        formViewerInstance.formIdList.push(parseInt(rootFormId));
        sectionList = formViewerInstance.formStructure.sectionList;
        rowRepeaterMap = formViewerInstance.rowRepeaterMap;

        promiseList.push(buildFormStructure(rootFormId, formRoot, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, null, printPreview, currencyCode, isConfigurableForm).then(function (rootFormStructure) {
            formViewerInstance.formStructure = rootFormStructure;
            formViewerInstance.formStructure.isAcordUpload = snippets.length > 0;
            formViewerInstance.formStructure.snippetList = snippets;
            formViewerInstance.formStructure.effectiveDate = parseInt(effectiveDate);
            formViewerInstance.formStructure.currencyCode = currencyCode;
        }));

        _.each(supplementalFormList, (supplementalFormRoot) => {
            promiseList.push(
                buildFormStructure(rootFormId, supplementalFormRoot, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, sectionList, printPreview, currencyCode).then(function (supplementalFormRootStructure) {
                    supplementalFormRootStructure.parentForm = formViewerInstance.formStructure;
                    supplementalFormRootStructure.autoHeight = true;
                    insertSupplementalForm(supplementalFormRootStructure, rootFormId);
                })
            );

        });

        _.each(rowRepeaterMap, (repeater) => {
            this.processCollapsibleColumnsAndVisibility(repeater.rowRepeaterId, rootFormId);
        });

        $q.all(promiseList).then(function () {
            $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED, rootFormId);
        });
    };

    this.buildStaticForm = function (uiFormTemplateId, uiFormTemplate, hasManageFormsRole) {
        let formViewerInstanceKey = uiFormTemplateId,
            formViewerInstance,
            fieldInstanceList = [],
            formSummaryList = [{
                root: true,
                id: uiFormTemplate.id,
                formTemplateId: uiFormTemplate.formTemplate.id,
                formTemplateUniqueName: uiFormTemplate.formTemplate.uniqueName
            }],
            formRowInstanceList = [],
            hasWriteAccess = hasManageFormsRole,
            printPreview = false,
            currencyCode = null,
            isConfigurableForm = true;

        reset(formViewerInstanceKey);
        formViewerInstance = formViewerModel[formViewerInstanceKey];

        buildFormStructure(formViewerInstanceKey, uiFormTemplate, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, null, printPreview, currencyCode, isConfigurableForm).then(function (rootFormStructure) {
            formViewerInstance.formStructure = rootFormStructure;

            $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED, formViewerInstanceKey);
        });
    };

    this.moveField = function (rootFormId, elementToMoveId, dropZoneFieldId, moveType) {
        let formViewerInstance = formViewerModel[rootFormId],
            result = formConfigurationUtil.moveField(formViewerInstance, elementToMoveId, dropZoneFieldId, moveType);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);

        return result;
    };

    this.createField = function (rootFormId, dropConfiguration, dropZoneFieldId) {
        let formViewerInstance = formViewerModel[rootFormId],
            newFieldStructure = formStructureUtil.createField(formViewerInstance, rootFormId, dropConfiguration);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);

        return this.moveField(rootFormId, newFieldStructure.fieldStructureId, dropZoneFieldId, dropConfiguration.dropType);
    };

    this.createSection = function (rootFormId, dropConfiguration, dropZoneFieldId, insertLocation) {
        let formViewerInstance = formViewerModel[rootFormId],
            newSectionStructure = formStructureUtil.createSection(formViewerInstance, rootFormId, dropConfiguration);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);

        return this.moveSection(rootFormId, newSectionStructure.sectionStructureId, dropZoneFieldId, insertLocation);
    };

    this.createRowRepeater = function (rootFormId, dropConfiguration, dropZoneRowId, insertLocation) {
        let formViewerInstance = formViewerModel[rootFormId],
            newRowStructure = formStructureUtil.createRowRepeater(formViewerInstance, rootFormId, dropConfiguration);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);

        return this.moveRow(rootFormId, newRowStructure.rowStructureId, dropZoneRowId, insertLocation);
    };

    this.moveSection = function (rootFormId, elementToMoveSectionId, dropZoneSectionId, moveType) {
        let formViewerInstance = formViewerModel[rootFormId],
            result = formConfigurationUtil.moveSection(formViewerInstance, elementToMoveSectionId, dropZoneSectionId, moveType);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);

        return result;
    };

    this.moveRow = function (rootFormId, elementToMoveRowId, dropZoneRowId, moveType) {
        let formViewerInstance = formViewerModel[rootFormId],
            result = formConfigurationUtil.moveRow(formViewerInstance, elementToMoveRowId, dropZoneRowId, moveType);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);

        return result;
    };

    this.deleteField = function (rootFormId, formStructureId) {
        let formViewerInstance = formViewerModel[rootFormId];

        formConfigurationUtil.deleteField(formViewerInstance, formStructureId);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    };

    this.deleteSection = function (rootFormId, sectionStructureId) {
        let formViewerInstance = formViewerModel[rootFormId];

        formConfigurationUtil.deleteSection(formViewerInstance, sectionStructureId);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    };

    this.deleteRow = function (rootFormId, rowStructureId) {
        let formViewerInstance = formViewerModel[rootFormId];

        formConfigurationUtil.deleteRow(formViewerInstance, rowStructureId);

        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    };

    this.addSupplementalForm = function (rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview) {
        const formViewerInstance = formViewerModel[rootFormId];

        if (!_.isNil(formViewerInstance)) {
            const formRoot = uiFormTemplateList[0];
            const formIdList = formViewerInstance.formIdList;
            const supplementalExists = formIdList.indexOf(formSummaryList[0].id) !== -1;
            const currencyCode = formViewerInstance.formStructure.currencyCode;

            if (!supplementalExists) {
                let maxTryCount = 5,
                    currentTryCount = 0;

                function buildSupplementalFormStructure() {
                    const formViewerInstance = formViewerModel[rootFormId];
                    const supplementalUiFormTemplate = uiFormTemplateList[0];
                    const rootFormSectionList = formViewerInstance.formStructure.sectionList;
                    const precedingFieldVariableName = supplementalUiFormTemplate.precedingFieldVariableName;
                    const precedingFieldFormTemplateUniqueName = supplementalUiFormTemplate.precedingFieldFormTemplateUniqueName;
                    const hasPrecedingFieldForm = supplementalFormUtil.doesPrecedingFormExist(precedingFieldVariableName, precedingFieldFormTemplateUniqueName, rootFormSectionList);

                    if (hasPrecedingFieldForm) {
                        buildFormStructure(rootFormId, formRoot, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, null, printPreview, currencyCode).then(function (supplementalFormRootStructure) {
                            let formTemplateUniqueName = formatUtil.formatAsSelector(supplementalFormRootStructure.formModel.formTemplateUniqueName);

                            supplementalFormRootStructure.parentForm = formViewerInstance.formStructure;
                            supplementalFormRootStructure.autoHeight = false;

                            insertSupplementalForm(supplementalFormRootStructure, rootFormId);
                            $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED);

                            $rootScope.$broadcast(formViewerConstant.event.SUPPLEMENTAL_FORM_ADDED, formTemplateUniqueName, supplementalFormRootStructure);
                        });
                    } else {
                        if (currentTryCount < maxTryCount) {
                            $timeout(() => {
                                currentTryCount += 1;
                                buildSupplementalFormStructure();
                            }, 500);
                        } else {
                            console.log('Unable to find preceding row when adding supplemental');
                        }
                    }
                }

                buildSupplementalFormStructure();
            }
        }
    };

    this.deleteSupplementalForm = function (supplementalForm, rootFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            formIdList = formViewerInstance.formIdList,
            supplementalExists = formIdList.indexOf(supplementalForm.id) !== -1;

        if (supplementalExists) {
            deleteSupplementalForm(supplementalForm, rootFormId);
            $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED);
        }
        return supplementalExists;
    };

    this.processRemoteRowDeletion = function (message, rootFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            rowRepeaterMap = formViewerInstance.rowRepeaterMap,
            fieldMap = formViewerInstance.fieldMap;

        rowRepeaterUtil.processRemoteRowDeletion(message, rowRepeaterMap, fieldMap);
    };

    this.processRemoteRowAddition = function (rowTemplateId, rowInstance, rootFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            rowRepeaterMap = formViewerInstance.rowRepeaterMap,
            fieldMap = formViewerInstance.fieldMap;

        rowRepeaterUtil.processRemoteRowAddition(rowTemplateId, rowInstance, rowRepeaterMap, fieldMap, rootFormId, formStructureUtil);
    };

    this.processRemoteRowUpdate = function (rowTemplateId, rowInstance, rootFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            rowRepeaterMap = formViewerInstance.rowRepeaterMap;

        rowRepeaterUtil.processRemoteRowUpdate(rowTemplateId, rowInstance, rowRepeaterMap);
    };

    this.sortRowRepeater = function (rootFormId, rowRepeaterId, sortKey, sortType) {
        let formViewerInstance = formViewerModel[rootFormId],
            rowRepeaterMap = formViewerInstance.rowRepeaterMap;

        rowRepeaterUtil.sortRowRepeater(rowRepeaterId, sortKey, sortType, rowRepeaterMap);
    };

    this.processCollapsibleColumnsAndVisibility = function (rowRepeaterId, rootFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            rowRepeaterMap = formViewerInstance.rowRepeaterMap;

        rowRepeaterUtil.processCollapsibleColumnsAndVisibility(rowRepeaterId, rowRepeaterMap);
    };

    this.processRootFormUpdate = function (form, rootFormId) {
        const formViewerInstance = formViewerModel[rootFormId];
        const isValidUpdate = formViewerInstance.formStructure.formModel.lastModificationDate <= form.lastModificationDate;
        const hasRequiredFieldLevelChange = formViewerInstance.formStructure.formModel.requiredFieldLevel !== form.requiredFieldLevel;
        const hasEditableFieldLevelChange = formViewerInstance.formStructure.formModel.editableFieldLevel !== form.editableFieldLevel;
        const hasReadOnlyChange = formViewerInstance.formStructure.formModel.readOnly !== form.readOnly;

        if (isValidUpdate) {
            if (hasRequiredFieldLevelChange || hasEditableFieldLevelChange || hasReadOnlyChange) {
                $rootScope.$broadcast(formViewerConstant.event.RELOAD_FORM);
            } else {
                formViewerInstance.formStructure.formModel = form;
                $timeout(function () {
                }, 0);
            }
        }
    };

    this.processFieldUpdate = function (fieldModel, rootFormId) {
        this.processFieldEvent(fieldModel, rootFormId);
    };

    this.processFieldDelete = function (fieldModel, rootFormId) {
        this.processFieldEvent(fieldModel, rootFormId, true/*isDeleteEvent*/);
    };

    this.processFieldRename = function (fieldModel, rootFormId) {
        this.processFieldEvent(fieldModel, rootFormId, false);
    };

    this.processFieldEvent = function (fieldModel, rootFormId, isDeleteEvent) {
        let localField,
            parentRowRepeater,
            formViewerInstance = formViewerModel[rootFormId],
            rowRepeaterMap = formViewerInstance.rowRepeaterMap,
            fieldMap = formViewerInstance.fieldMap;

        if (fieldModel.rowId) {
            localField = fieldMap.get(rootFormId + '-' + fieldModel.fieldTemplateId + '-' + fieldModel.rowId);
            if (localField) {
                localField.fieldModel = isDeleteEvent ? null : fieldModel;
                formComponentUtil.setupFieldProperties(localField);
                parentRowRepeater = rowRepeaterMap[localField.rowRepeaterId];
                parentRowRepeater.timeLastModified = fieldModel.timeLastModified;
                this.processCollapsibleColumnsAndVisibility(localField.rowRepeaterId, rootFormId);
            }
        } else {
            localField = fieldMap.get(rootFormId + '-' + fieldModel.fieldTemplateId);
            if (localField) {
                localField.fieldModel = isDeleteEvent ? null : fieldModel;
                formComponentUtil.setupFieldProperties(localField);
            }
        }
        $timeout(function () {
        }, 0);
    };

    this.updateFieldStructureConfiguration = function (componentStructure, suppressFormEvents) {
        let rootFormId = componentStructure.rootFormId,
            formViewerInstance = formViewerModel[rootFormId],
            currencyCode = formViewerInstance.formStructure.currencyCode,
            isRowRepeater = componentStructure.repeating,
            isRowRepeaterField = componentStructure.isRowRepeaterField;

        function updateRowRepeaterStructure(repeaterRowStructure) {
            let rowRepeaterFieldIndex = _.findIndex(repeaterRowStructure.rowTemplate.fields, function (uiField) {
                return uiField.fieldTemplate.type === fieldType.ROWREPEATER;
            });

            repeaterRowStructure.rowRepeaterName = rowRepeaterUtil.getRowRepeaterName(repeaterRowStructure.rowTemplate.repeaterField);
            repeaterRowStructure.repeaterFieldStructure.uiField = repeaterRowStructure.rowTemplate.repeaterField;
            formComponentUtil.setupFieldProperties(repeaterRowStructure.repeaterFieldStructure, currencyCode);

            repeaterRowStructure.rowTemplate.fields[rowRepeaterFieldIndex] = repeaterRowStructure.rowTemplate.repeaterField;
            $rootScope.$broadcast(formViewerConstant.configuration.event.UPDATE_ROW_REPEATER_SETTING, repeaterRowStructure);
        }

        if (isRowRepeaterField) {
            componentStructure.hideLabel = formViewerInstance.formStructure.isConfigurableForm;
        }

        if (isRowRepeater) {
            updateRowRepeaterStructure(componentStructure);
        } else {
            formComponentUtil.setupFieldProperties(componentStructure, currencyCode);
            $rootScope.$broadcast(formViewerConstant.configuration.event.UPDATE_COMPONENT_SETTING, componentStructure);
        }

        if (suppressFormEvents !== true) {
            $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
        }
    };

    this.getFormStructure = function (rootFormId) {
        let form = formViewerModel[rootFormId] || {};
        return form.formStructure;
    };

    this.getFieldMap = function (rootFormId) {
        return formViewerModel[rootFormId].fieldMap;
    };

    this.shouldProcessForm = function (rootFormId, eventFormId) {
        let formViewerInstance = formViewerModel[rootFormId],
            formIdList = formViewerInstance.formIdList;

        return formIdList.indexOf(eventFormId) !== -1;
    };

    this.resetForm = function (rootFormId) {
        formViewerModel[rootFormId] = null;
    };
};

angular.module('umFormViewer').service('formViewerModel', FormViewerModel);
